import React from "react";
import handleState from "./handleState";

const BubbleWithTextViewGradingPage = ({ state, text }) => {
    return (
        <>
            <div className="bubble-with-text-view">
                <div className={`bubble ${handleState(state)}`} style={{ cursor: "auto" }}/>
                { text }
            </div>
        </>
    );
}

export default BubbleWithTextViewGradingPage;